import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import CreateCategory from './CreateCategory'
import ListCategories from './ListCategories'
import EditCategory from './EditCategory'

const Categories = ({ match }) => (
  <div>
    <Route
      exact
      path={match.url}
      render={props => <ListCategories {...props} />}
    />
    <Switch>
      <Route exact path={`${match.url}/add`} component={CreateCategory} />
      <Route
        path={`${match.url}/:id`}
        render={props => <EditCategory {...props} />}
      />
    </Switch>
  </div>
)

Categories.propTypes = {
  match: PropTypes.object.isRequired
}

export default Categories
